/**
 * @fileoverview Mixin del Centro de Ayuda con la búsqueda por palabra clave.
 * `search` (prop) solo siembra y sincroniza el término externo; el estado vivo es `searchQuery`, así el
 * componente no muta su propia prop. Cada cambio de `searchQuery` consulta la búsqueda y registra "search".
 *
 * Requiere las props `search` y `listProducts`, el catálogo (`products`, `selectProduct`, `selectMenu`,
 * `questionActive`) y help-center-tracking.mixin (`trackSearch`). En `mixins` va después del catálogo:
 * así el catálogo se pide primero al montar.
 * @module mixins/help-center-search.mixin
 */

import { searchQuestions } from '@/services/help-center.service'
import { buildSearchResults } from '@/utils/help-center-content'
import { ICONS } from '@/constants/help-center'

export default {
  data () {
    return {
      searchQuery: this.search,
      textSearch: '',
      resultSearch: [],
      flagSearch: false,
      iconSearching: ICONS.SEARCH
    }
  },
  watch: {
    search (value) {
      this.searchQuery = value
    },
    searchQuery (value) {
      this.textSearch = value
      this.runSearch(value)
    }
  },
  mounted () {
    if (this.searchQuery) this.runSearch(this.searchQuery)
  },
  methods: {
    /**
     * Consulta la búsqueda, deja en `resultSearch` las filas de los productos del usuario y registra "search".
     * Con el término vacío (salir de la vista de resultados) no se consulta y la lista queda vacía.
     * @param {string} term - Texto buscado
     */
    runSearch (term) {
      this.flagSearch = true
      searchQuestions(this.listProducts, term)
        .then(questions => {
          this.resultSearch = []
          this.resultSearch = buildSearchResults(questions, this.products.map(product => product.code))
        })
        .catch(() => {})
        .finally(() => { this.flagSearch = false })
      this.trackSearch(term)
    },

    /** Envía lo escrito en el buscador (Enter o clic en la lupa). */
    onEnterLocal () {
      this.iconSearching = ICONS.SEARCH
      this.searchQuery = this.textSearch
    },

    /** Cambia el ícono de la lupa al hacer clic en el input. */
    changeIcon () {
      this.iconSearching = ICONS.BACK
    },

    /** Vacía el input (botón X). No sale de la vista de resultados. */
    clear () {
      this.textSearch = ''
      this.iconSearching = ICONS.BACK
    },

    /**
     * Abre el producto, el tema y la pregunta de un resultado y sale de la búsqueda.
     * @param {string} plan - Código del producto del resultado
     * @param {string} topicId - Id del tema de la pregunta
     * @param {string} questionId - Id de la pregunta
     */
    go (plan, topicId, questionId) {
      this.searchQuery = ''
      this.selectProduct(plan)
      this.selectMenu(topicId)
      this.questionActive = questionId
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/help-center-search.mixin.js